import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const deleteQuestionApiImpl = async (questionId: string): Promise<Either<ErrorEntity, void>> =>{
    try {
        const relativeUrl = `/question/${questionId}`;
        const response = await di.get<HostApi>(HostApiName).remove(relativeUrl);
        return right(undefined);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default deleteQuestionApiImpl;